import StickyHeader from "./StickyHeader";
const stickyNavSelector = ".js-sticky-nav";
const stickyNavStuckClass = "is-stuck";
const stickyNavs = document.querySelectorAll(stickyNavSelector);
/**
 * Set top value to sticky navigation dynamically if sticky header is in affixed state.
 */
function setOffsetToStickyNav() {
    if (!stickyNavs.length)
        return;
    document.addEventListener("affixed.restaumatic.sticky-header", () => {
        if (!StickyHeader.utils.isHeaderSticky())
            return;
        stickyNavs.forEach((nav) => {
            nav.style.top = `${StickyHeader.utils.getStickyHeaderHeight()}px`;
            document.documentElement.style.setProperty("--sticky-header-height", `${StickyHeader.utils.getStickyHeaderHeight()}px`);
        });
    });
}
/**
 * Toggle is-stuck class on each sticky nav when it is pinned at the top.
 * Uses IntersectionObserver to detect when nav reaches its stick point.
 */
function observeNavStuckState() {
    if (!stickyNavs.length)
        return;
    let observer = null;
    function setup() {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        const headerHeight = StickyHeader.utils.getStickyHeaderHeight();
        observer = new IntersectionObserver(([entry]) => {
            const isStuck = entry.boundingClientRect.top <= headerHeight;
            entry.target.classList.toggle(stickyNavStuckClass, isStuck);
        }, { rootMargin: `-${headerHeight}px 0px -100% 0px` });
        stickyNavs.forEach((nav) => observer.observe(nav));
    }
    setup();
    document.addEventListener("affixed.restaumatic.sticky-header", setup);
}
/**
 * Sticky Navigation.
 */
export default {
    init: () => {
        setOffsetToStickyNav();
        observeNavStuckState();
    },
};
